import axios from 'axios'
import base from '../../../base'
import resource from '../resource'
import {
  SET_PAGE,
  SET_PAGE_SIZE,
  SET_TOTAL_PAGES,
  REQUEST_DATA_SUCCESS
} from './mutation-types'

export default {
  requestData({ commit }, payload) {
    const config = {
      url: resource,
      baseURL: base,
      params: payload
    }

    config.params.sort = 1

    return axios(config).then(({ data }) => {
      const page = data.Page
      const total = data.PageCount
      const result = data.Result
      commit(SET_PAGE, page)
      commit(SET_TOTAL_PAGES, total)
      commit(REQUEST_DATA_SUCCESS, result)
    })
  },
  setPageSize({ commit }, payload) {
    commit(SET_PAGE_SIZE, payload)
  },
  removeItem(_, payload) {
    const config = {
      method: 'delete',
      url: `${resource}/${payload}`,
      baseURL: base
    }

    return axios(config)
  }
}
